import React, { ReactNode } from "react";
import { cn } from "../../styles";
import { Typography, TypographyContent } from "../../atoms";
import { LocalizationScope } from "../../util/LocalizationScope";

export interface TraitFrameProps {
  children: ReactNode;
  label?: TypographyContent;
  localKey?: string;
  active?: boolean;
  required?: boolean;
  renderPresetActions?: () => ReactNode;
  onClick?: () => void;
  className?: string;
}

export const TraitFrame = ({
  children,
  label,
  localKey,
  active,
  required,
  renderPresetActions,
  onClick,
  className,
}: TraitFrameProps) => {
  return (
    <div
      className={cn(
        "rounded-xl border bg-white dark:bg-back-900 shadow-sm",
        active === true && "border-primary-300 shadow-md",
        active === false && "border-back-200 shadow-none",
        active === undefined && "border-back-200",
        onClick && "cursor-pointer hover:shadow-md transition-shadow",
        className
      )}
      onClick={onClick}
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-start px-4 pt-3 pb-1">
          <LocalizationScope scope={localKey}>
            <Typography.H4
              content={label || (localKey ? { local: "Trait" } : undefined)}
            >
              {required && (
                <span className="text-red-500 ml-0.5 text-xs align-super">
                  *
                </span>
              )}
            </Typography.H4>
          </LocalizationScope>
          {renderPresetActions && <div>{renderPresetActions()}</div>}
        </div>
        <div className="px-4 pb-3">{children}</div>
      </div>
    </div>
  );
};

TraitFrame.displayName = "TraitFrame";
